export default __webpack_public_path__ + "static/media/undo.59066704.svg";